var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { linkStyles } from './styles';
import { linkContents } from './shared';
/**
 * [Storybook](https://guardian.github.io/source/?path=/docs/source-src-link-button-link) •
 * [Design System](https://theguardian.design/2a1e5182b/p/43c26b-link/b/048fd1) •
 * [GitHub](https://github.com/guardian/source/tree/main/src/core/components/link) •
 * [NPM](https://www.npmjs.com/package/@guardian/src-link)
 *
 * Links are used as navigational aids. They may appear inline in a paragraph, as items in a list or as stand alone text elements.
 *
 * The following themes are supported: `light`, `brand`, `brandYellow`
 */
export const ButtonLink = (_a) => {
    var { priority = 'primary', subdued: isSubdued, icon: iconSvg, iconSide = 'left', cssOverrides, children } = _a, props = __rest(_a, ["priority", "subdued", "icon", "iconSide", "cssOverrides", "children"]);
    return (_jsx("button", Object.assign({ css: linkStyles({
            isButton: true,
            priority,
            isSubdued,
            iconSvg,
            iconSide,
            cssOverrides,
        }) }, props, { children: linkContents({ children, iconSvg, iconSide }) }), void 0));
};
//# sourceMappingURL=ButtonLink.js.map
